export class TenantLicense {
  label: string;
  coarseLevel: LicenseCoarseLevels;
  fineLevel: LicenseFineLevels;
  trialExpirationDate: number | null;

  public isTrial(): boolean {
    return this.fineLevel === LicenseFineLevels.trial;
  }

  public isEnterprise(): boolean {
    return this.coarseLevel === LicenseCoarseLevels.enterprise;
  }

  public isPremium(): boolean {
    return this.coarseLevel === LicenseCoarseLevels.premium;
  }

  public isFreemium(): boolean {
    return this.coarseLevel === LicenseCoarseLevels.freemium;
  }

  constructor(
    isCuripodEnterprise: boolean,
    isCuripodPremium: boolean,
    curipodTrialExpirationDate?: number,
  ) {
    if (isCuripodEnterprise) {
      this.label = 'Enterprise';
      this.coarseLevel = LicenseCoarseLevels.enterprise;
      this.fineLevel = LicenseFineLevels.full;
    } else if ((curipodTrialExpirationDate ?? 0) > Date.now()) {
      const daysLeft = Math.floor(
        ((curipodTrialExpirationDate ?? 0) - Date.now()) / (1000 * 60 * 60 * 24),
      );
      this.label = '⌛ ' + daysLeft + ' days';
      this.coarseLevel = LicenseCoarseLevels.enterprise;
      this.fineLevel = LicenseFineLevels.trial;
    } else if (isCuripodPremium) {
      this.label = 'Premium';
      this.coarseLevel = LicenseCoarseLevels.premium;
      this.fineLevel = LicenseFineLevels.full;
    } else {
      this.label = 'Freemium';
      this.coarseLevel = LicenseCoarseLevels.freemium;
      this.fineLevel = LicenseFineLevels.full;
    }
    this.trialExpirationDate = curipodTrialExpirationDate ?? null;
  }
}

export enum LicenseCoarseLevels {
  enterprise = 'enterprise',
  premium = 'premium',
  freemium = 'freemium',
}

export enum LicenseFineLevels {
  trial = 'trial',
  full = 'full',
}
